import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilValue, useRecoilState } from "recoil";
import { SendMoneyIcon, CloseIcon, UFO, Telegram } from "../../../../assets/Icons";
import Modal from "../../../../components/ui/Modal";
import RecipientCard from "../../../../components/ui/RecipientCard";
import Typograpy from "../../../../components/ui/Typography";
import { getOfflineRecipients } from "../../../../services/offline";
import { offlineSBM, recipientDetails, searchValue } from "../../../../store";

export const OfflineSBMPickRecipient = () => {
  const navigate = useNavigate();
  const recipientDetailsData = useRecoilValue(recipientDetails);
  const [recipient, setRecipient] = useRecoilState(recipientDetails);
  const [searchInput, setSearchInput] = useRecoilState(searchValue);
  const [filteredRecipient, setFilteredRecipient] = useState(recipientDetailsData);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [offlineSbmData, setOfflineSbmData] = useRecoilState(offlineSBM);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const offlineRemitter = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");

  const getRecipients = async () => {
    getOfflineRecipients(currentUser, offlineRemitter).then((response) => {
      setRecipient(response?.data?.recipient);
    });
  };
  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  });

  useEffect(() => {
    if (searchInput) {
      setFilteredRecipient(
        recipientDetailsData.filter(
          (el: any) => el?.name.toLowerCase().includes(searchInput.toLowerCase())
          // ||
          // el.lastName.toLowerCase().includes(searchInput.toLowerCase()),
        )
      );
    } else {
      setFilteredRecipient(recipientDetailsData);
    }
  }, [searchInput, recipientDetailsData, recipient]);

  useEffect(() => {
    getRecipients();
  }, []);

  // const handleChoseRecipient = () => {
  //   navigate("/1/documents");
  //   setOfflineSbmData({ ...offlineSbmData, id_recipient:  });
  // };

  return (
    <div>
      <div className="flex flex-col p-6 mt-3 w-[1370px]">
        <div id="header" className="flex items-center justify-between">
          <div id="left" className="flex items-center space-x-5">
            <SendMoneyIcon width="32px" height="32px" />
            <span className="font-bold text-[28px]">Recipient</span>
          </div>
          <div id="right" onClick={() => navigate("/home")} className="ml-[500px] cursor-pointer">
            <CloseIcon fill="black" />
          </div>
        </div>
        <div id="searchAndAdd" className="px-10 mt-10 space-y-5">
          <input
            name="searchRecipient"
            type="text"
            placeholder="Search Recipient Name..."
            onChange={(e) => setSearchInput(e.target.value)}
            className="w-full p-4 bg-gray-200 rounded-md"
            autoComplete="off"
            pattern="[a-zA-Z0-9 ]{1,}"
          />
          <div className="w-full py-5 md:py-10 pl-8 md:pl-10 flex items-center text-white bg-[#14B1E7] gap-6 md:gap-12 rounded-[6px] mb-4">
            <Link to={"/1/recipient-details"}>
              <div className="w-9 h-9 md:w-[56px] md:h-[56px] bg-[transparent] rounded-full border-white border-[3px] text-xl md:text-[40px] text-white flex justify-center items-center text-center cursor-pointer add-recepient-btn">
                <div className="mb-2">+</div>
              </div>
            </Link>
            <Typograpy
              className="text-white opacity-70 text-base md:text-[30px] font-normal Recepient-add-text"
              text={"Click the “ ADD “ button to add recepients"}
              tagType="div"
            />
          </div>
        </div>
        <div>
          {recipientDetailsData?.length === 0 ? (
            <div className="flex flex-col items-center text-center mt-32 md:mt-[186px]">
              <div>
                <UFO />
              </div>
              <Typograpy
                tagType="div"
                className="text-[32px] md:text-[48px] text-primary-600 font-normal mb-9 md:mb-[17px]"
                text="No recepients found"
              />
              <Typograpy
                tagType="div"
                className="text-singleHistoryText text-[40px] md:text-[72px]"
                text={
                  <span>
                    Try the <span className="opacity-50 text-primary-600">“add”</span> button above
                  </span>
                }
              />
            </div>
          ) : (
            filteredRecipient?.map((el: any) => {
              return (
                <RecipientCard
                  key={el?.bankAccountNumber}
                  firstName={el?.name}
                  // lastName={el?.lastName}
                  bankAccountCountry={el?.bankAccountCountry}
                  accNo={el?.bankAccountNumber}
                  onButtonClick={() => {
                    setOfflineSbmData({
                      ...offlineSbmData,
                      id_recipient: el?.id,
                    });
                    navigate("/1/documents");
                  }}
                  icon={<Telegram />}
                  id={el?.id}
                  name={el?.firstName}
                  acNumber={el?.bankAccountNumber}
                />
              );
            })
          )}
        </div>
      </div>
      <Modal
        header="Cancel Transaction"
        headerClass={"bg-primary !my-0 py-6 pr-6 lg:pl-12 pl-[30px] text-xl font-medium text-white"}
        modalClass="!p-0 rounded-[10px] lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
        visible={isModalOpen === "cancel"}
        closeHandler={() => setIsModalOpen("")}
      >
        <div className="flex flex-col items-center p-10 space-y-6">
          <span className="font-ssp text-[22px]">
            Are you sure you want to cancel the transaction?
          </span>
          <div className="flex space-x-10">
            <button
              onClick={() => navigate("/remittance")}
              className="px-6 py-2 font-bold text-white rounded bg-primary-650 font-ssp"
            >
              Yes
            </button>
            <button
              onClick={() => setIsModalOpen("")}
              className="px-6 py-2 font-bold text-white rounded bg-primary font-ssp"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
